<template>
  <div
    class="m-auto flex justify-center text-gray-darkest leading-normal first:pt-4 last:pb-4 [&_ol]:list-decimal [&_ol]:pl-4 [&_ul]:pl-4 [&_ul]:list-square [&_li>p]:mb-2 [&_p]:mb-4 last:[&_div>p]:mb-0 [&_h2]:text-2xl lg:[&_h2]:text-3xl [&_h3]:text-xl lg:[&_h3]:text-2xl [&_h4]:text-lg lg:[&_h4]:text-xl"
  >
    <div class="relative w-full max-w-3xl mx-4 py-4">
      <component :is="headingTag" v-if="data.heading" :id="headingId" class="text-inherit normal-case mt-0 mb-4">
        {{ translateTemplate(data.heading) }}
      </component>
      <CmsWidgetTextElement v-if="data.text" :data="data.text" />
      <div
        v-if="data.heading && isIdVisible"
        class="text-gray rounded border border-gray-light py-1 px-2 bg-white text-sm absolute top-4 right-0"
      >
        #{{ headingId }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $storyblok } = useNuxtApp()
const { translateTemplate } = useTemplateTranslator()

interface TextSection {
  heading: string
  headingTag: 'h1' | 'h2' | 'h3' | 'h4'
  text: StoryblokTextBlock
}

const { data } = defineProps<{
  data: TextSection
}>()

const headingTag = computed(() => {
  return data.headingTag.toLowerCase() || 'h2'
})

const headingId = computed(() => {
  return `id-${slugifyString(data.heading)}`
})

// Show the heading id in edit/preview mode
const isIdVisible = computed(() => {
  return $storyblok.isEditing.value || $storyblok.isPreview.value
})
</script>
